import React, { useState } from "react";
import {
  AiFillEye,
  AiOutlineAppstoreAdd,
  AiOutlineDelete,
} from "react-icons/ai";
import { Link } from "react-router-dom";
import { RoutePath } from "../../utilities/Constants";
import { FiEdit } from "react-icons/fi";
import defaultBusLight from "../../assets/images/default-bus-green.png";
import defaultLaunchLight from "../../assets/images/default-launch-green.png";
import defaultPlaneLight from "../../assets/images/default-plane-green.png";
import defaultTrainLight from "../../assets/images/default-train-green.png";
import defaultBikeLight from "../../assets/images/default-bike-green.png";
import defaultCngLight from "../../assets/images/default-cng-green.png";
import defaultWatertaxiLight from "../../assets/images/default-watertaxi-green.png";

function TransportCard({ project, user, handleSingleDelete, intercity }) {
  const { productAdd, intercityAdd } = RoutePath;
  const [showMore, setShowMore] = useState(false);
  const [visibility, setVisibility] = useState(true);

  const handleDelete = async () => {
    const res = await handleSingleDelete(project._id);
    if (typeof res === "boolean" && res === true) {
      setVisibility(false);
    }
  };

  const getDefaultImg = (type) => {
    if (type === "bus") {
      return defaultBusLight;
    } else if (type === "launch") {
      return defaultLaunchLight;
    } else if (type === "plane") {
      return defaultPlaneLight;
    } else if (type === "train") {
      return defaultTrainLight;
    } else if (type === "bike") {
      return defaultBikeLight;
    } else if (type === "cng") {
      return defaultCngLight;
    } else if (type === "water taxi") {
      return defaultWatertaxiLight;
    } else {
      return defaultBusLight;
    }
  };

  return (
    <>
      {visibility ? (
        <div
          className={`group relative h-full flex flex-col lg:flex-row justify-between overflow-hidden bg-white dark:bg-darkModeBg dark:border-gray-600 border-dashed ${
            project
              ? "border"
              : "border hover:border-secondary dark:hover:border-secondary transition-colors duration-150"
          } rounded-lg w-full`}
        >
          {project ? (
            <>
              <div className="flex items-center p-1 px-4">
                <figure className="border dark:border-[#333] rounded-md bg-gray-100 h-20 aspect-square block">
                  <img
                    src={
                      project?.image?.url
                        ? project?.image?.url
                        : getDefaultImg(project.category)
                    }
                    alt={project?.busName}
                    className="object-cover w-full h-full rounded-md"
                  />
                </figure>

                {/* title and stoppage container */}
                <div className="p-4 h-auto flex flex-col gap-1 justify-between">
                  <div className="w-full pb-2 transition-all duration-150">
                    {/* title container */}
                    <div className="flex flex-col sm:flex-row mb-1 gap-1 sm:items-center text-gray-700 dark:text-darkWhite sm:gap-4 sm:mb-0">
                      {/* Bus title */}
                      <h2 className="text-base lg:text-lg font-semibold line-clamp-3">
                        {project?.busName}
                      </h2>

                      <span className="flex flex-wrap items-center gap-2 text-sm dark:text-gray-700">
                        <span className="capitalize bg-green-200 dark:bg-green-300 rounded-md py-0.5 px-1.5">
                          {project.category}
                        </span>
                        {project?.city?.length > 0 && (
                          <span className="capitalize bg-gray-200 dark:bg-gray-300 rounded-md py-0.5 px-1.5">
                            {project.city}
                          </span>
                        )}
                      </span>
                    </div>
                    {/* stoppage */}
                    <div
                      className={`relative text-sm lg:text-base w-full text-gray-400 font-normal line-clamp-2 lg:pr-8`}
                    >
                      {project?.stoppage?.map(
                        (item, idx) =>
                          item?.nameEn && (
                            <span
                              key={idx}
                              className={` after:content-['•'] mx-0.5 last:after:content-['']`}
                            >
                              {item.nameEn}{" "}
                            </span>
                          )
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-3 px-4 flex justify-between items-center dark:border-gray-600 gap-2 text-sm md:text-base border-t lg:border-t-0 lg:border-l border-dashed">
                <a
                  href={`https://route-planner-frontend.vercel.app/transport?from=&to=&type=${
                    intercity ? "intercity" : "local"
                  }&qid=${project._id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-1.5 text-xl text-green-600 hover:text-green-50 hover:bg-green-600 transition-colors duration-200 rounded-lg"
                >
                  <AiFillEye />
                </a>
                <Link
                  title="Edit"
                  to={`/${intercity ? "intercity" : "local"}/${project._id}`}
                  className="btn btn-outline btn-xs border-blue-500 text-blue-500 hover:bg-blue-500 hover:border-blue-500 hover:text-white h-fit px-2 py-2.5 transition duration-150  text-center rounded-lg text-xl"
                >
                  <FiEdit />
                </Link>
                {user === "admin" && (
                  <button
                    title="Delete"
                    id={project._id}
                    onClick={handleDelete}
                    className="btn btn-outline btn-xs border-red-500 text-red-500 hover:bg-red-500 hover:border-red-500 hover:text-white h-fit px-2.5 py-2.5 transition duration-150  text-center rounded-lg text-xl"
                  >
                    <AiOutlineDelete />
                  </button>
                )}
              </div>
            </>
          ) : (
            <Link
              className="h-full w-full"
              to={`/${intercity ? intercityAdd : productAdd}`}
            >
              <div className="w-full h-full flex justify-center items-center py-4">
                <div className="text-5xl w-fit text-gray-500 group-hover:text-secondary transition-colors duration-150">
                  <AiOutlineAppstoreAdd />
                </div>
              </div>
            </Link>
          )}
        </div>
      ) : null}
    </>
  );
}

export default TransportCard;
